import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form.email, form.password);
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-24 lg:py-32">
      <div className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-4">◦ Welcome back</div>
      <h1 className="font-serif text-5xl lg:text-6xl tracking-tight font-light">Sign in.</h1>
      <form onSubmit={submit} className="mt-12 space-y-6">
        <div>
          <label className="text-xs tracking-[0.2em] uppercase text-muted-foreground">Email</label>
          <input
            data-testid="login-email"
            type="email" required
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-transparent border-b border-border focus:border-primary outline-none py-3 mt-2 text-base transition-colors"
          />
        </div>
        <div>
          <label className="text-xs tracking-[0.2em] uppercase text-muted-foreground">Password</label>
          <input
            data-testid="login-password"
            type="password" required
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full bg-transparent border-b border-border focus:border-primary outline-none py-3 mt-2 text-base transition-colors"
          />
        </div>
        {error && <div data-testid="login-error" className="text-sm text-destructive">{error}</div>}
        <div className="text-right -mt-2">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-muted-foreground hover:text-primary transition-colors">Forgot password?</Link>
        </div>
        <button
          data-testid="login-submit"
          disabled={loading}
          className="btn-primary w-full py-3.5 text-sm tracking-wide rounded-sm disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <div className="text-sm text-muted-foreground text-center pt-4">
          New to Alteza? <Link to="/register" className="text-foreground hover:text-primary transition-colors">Create an account →</Link>
        </div>
      </form>
    </div>
  );
}
